import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-student-idcard',
  templateUrl: './student-idcard.component.html',
  styleUrls: ['./student-idcard.component.css']
})
export class StudentIDCardComponent implements OnInit {

  constructor(private financeService:FinanceService,private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
  SearchFilter = {
    ClassID: 0,
    SectionID: 0,
    StudentID:0,
    CurrentIndex: 0,
    PageSize: 20
}
currentPage = 1;
pageSize = 20;
recordCount = 0;
totalPages = 0;
StudentIDCardModel:any;
numberOfPages  () {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
}
nextPage  () {
    this.currentPage = this.currentPage + 1;
}
pageSizes  () {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
}
ClassList:any;
SectionSearchList:any;
GetClass  () {
     this.lookupService.GetLookupsList('Class', '').subscribe( (data)=> {
        this.ClassList = data.LookupItems;
    });
};
GetSectionSearch  () {
    
    this.SearchFilter.SectionID = 0;
    var ItemBo = {
        'ItemId': this.SearchFilter.ClassID
    }
     this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.SectionSearchList = data.LookupItems;
       

    });
};
StudentList = {}
Student:any;
GetStudent  () {
    
    
    this.SearchFilter.StudentID = 0;
    var itemBo = {
        'ItemId': this.SearchFilter.ClassID,
        'ItemId2': this.SearchFilter.SectionID
    };
     this.lookupService.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe( (data)=> {
        this.Student = data.LookupItems;
       
    });
};
ListStuAdmission:any;
BranchDetails:any;
SearchStuAdmission  () {
  this.spinnerService.show();
    this.SearchFilter.CurrentIndex = this.currentPage;
    this.SearchFilter.PageSize = this.pageSize;
    this.studentService.GetAllStudentIDCard(JSON.stringify(this.SearchFilter)).subscribe( (data)=> {
        this.ListStuAdmission = data.ListStuAdmission;
        this.BranchDetails = data.BranchDetails;
        this.recordCount = 0;
        if (data.ListStuAdmission != null && data.ListStuAdmission.length > 0) {
            this.recordCount = data.ListStuAdmission[0].RecordCount;
        }
        this.spinnerService.hide();
        this.numberOfPages();
        
    });
};

Clear  () {
    this.SearchFilter.ClassID = 0;
    this.SearchFilter.SectionID = 0;
    this.SearchFilter.StudentID = 0;
}

  ngOnInit() {
    this.GetClass();
    this.SearchStuAdmission();
  }
  PrintButton = true;
  IsSelect = false
    SelectAll() {
        if (this.IsSelect) {
            for (var i = 0; i < this.ListStuAdmission.length; i++) {
                this.ListStuAdmission[i].IsActive = true;
                this.PrintButton = false;
            }
        }
        if (this.IsSelect == false) {
            for (var i = 0; i < this.ListStuAdmission.length; i++) {
                this.ListStuAdmission[i].IsActive = false;
                this.PrintButton = true;
            }
        }
    }
    Count1 = 0;
    ChangeSelect(item) {
        this.Count1 = 0;
        for (var i = 0; i < this.ListStuAdmission.length; i++) {
            if (this.ListStuAdmission[i].IsActive) {
                this.Count1 = this.Count1 + 1
                this.PrintButton = false;
            }
        }
        if (this.Count1 == this.ListStuAdmission.length) {
            this.IsSelect = true;
            this.PrintButton = false;
        }
        else {
            this.IsSelect = false;
        }

    }

  // Print
 
    AllPrint() {
        
        var objStudent = '';
        

        for (var i = 0; i < this.ListStuAdmission.length; i++) {
            if (this.ListStuAdmission[i].IsActive) {
                objStudent = objStudent == '' ? this.ListStuAdmission[i].StudentID : objStudent + ',' + this.ListStuAdmission[i].StudentID;
             
            }
        }

       
       
        var url = "printidcard?ClassID=" + this.SearchFilter.ClassID + "&SectionID=" + this.SearchFilter.SectionID+ "&StudentID=" + this.SearchFilter.ClassID + "&StudentIDs=" + objStudent ;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

    }
  printdetails(item) {
    var url = "printidcard?ClassID=" + item.ClassID + "&SectionID=" + item.SectionID+ "&StudentID=" + item.StudentID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");    
}

printbulkidcard() {
    var url = "printidcard?ClassID=" + this.SearchFilter.ClassID + "&SectionID=" + this.SearchFilter.SectionID+ "&StudentID=" + this.SearchFilter.StudentID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    
}
}
